/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from 'underscore';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { getStyles } from './accordion-header-styles';

const AccordionHeaderUnstyled = (props) => {
  const {
    classes,
    className,
    children,
    expanded,
    helpId,
    onChange,
    titleId,
    i18n,
  } = props;

  // pass data-* props to <a> for attributes to be read from click event for target
  const dataProps = _.pick(props, (value, key) => _.isString(key) && key.startsWith('data-'));
  const handleClick = useCallback((e) => {
    onChange(e, !expanded);
    e.preventDefault();
  }, [expanded, onChange]);

  return (
    <div className={classNames('accordion-header', classes.accordionTitle, className)}>
      <a
        className={classNames('title', { collapsed: !expanded })}
        onClick={handleClick}
        role="button"
        href="#"
        aria-expanded={expanded ? 'true' : 'false'}
        {...dataProps}
        {...(titleId ? { id: titleId } : {})}
      >
        {children}
      </a>
      {helpId && (
        <HelpButton aria-label={i18n.getString(_TL_('Learn more'))} topic={helpId} />
      )}
    </div>
  );
};

AccordionHeaderUnstyled.propTypes = {
  classes: PropTypes.shape({
    accordionTitle: PropTypes.string,
    helpButton: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  children: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  helpId: PropTypes.string,
  titleId: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

AccordionHeaderUnstyled.defaultProps = {
  className: undefined,
  helpId: undefined,
  titleId: undefined,
};

export const AccordionHeader = withDefaultStyles(AccordionHeaderUnstyled, getStyles);
